import React, { useState, useRef, useEffect } from 'react';
import Auxi from '../../../hoc/Auxi/Auxi';

const loadMoreText = (props) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const [showButton, setShowButton] = useState(false);
	const textRef = useRef(null);

	useEffect(() => {
		if (textRef.current) {
			// Check if text exceeds 3 lines
			const lineHeight = parseFloat(getComputedStyle(textRef.current).lineHeight);
			const maxHeight = lineHeight * 3;
			if (textRef.current.scrollHeight > maxHeight) {
				setShowButton(true);
			}
		}
	}, [props.children]);

	const toggleExpanded = () => {
		setIsExpanded(!isExpanded);
	};

	return (
		<Auxi>
			<div
				ref={textRef}
				style={{
					display: '-webkit-box',
					WebkitLineClamp: isExpanded ? 'unset' : 3,
					WebkitBoxOrient: 'vertical',
					overflow: isExpanded ? 'visible' : 'hidden',
					textOverflow: 'ellipsis',
					transition: 'all 0.3s ease',
				}}
			>
				{props.children}
			</div>
			{showButton && (
				<button
					onClick={toggleExpanded}
					style={{
						marginTop: '0.5rem',
						background: 'none',
						border: 'none',
						color: 'var(--color-primary)',
						cursor: 'pointer',
						fontSize: '0.85rem',
						fontWeight: 600,
						padding: 0,
						textDecoration: 'underline',
					}}
				>
					{isExpanded ? 'Show Less' : 'Show More'}
				</button>
			)}
		</Auxi>
	);
};

export default loadMoreText;


// WEBPACK FOOTER //
// ./src/components/UI/LoadMoreText/LoadMoreText.js